export default {
    methods: {
        toTitle( str ) {
            let words = str.toLowerCase().split(" ");
            let cappedWords = words.map(s => {
                return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
            });
            return cappedWords.join(" ");
        },
        restrictToAlphabet( charCode, evt ) {
            // Key event is for a browser shortcut
            if ( evt.metaKey || evt.ctrlKey ) {
                return true;
            }

            // If keycode is a space
            if ( evt.which === 32 ) {
                return false;
            }

            // If keycode is a special char (WebKit)
            if ( evt.which === 0 ) {
                return true;
            }

            // Allow plus for phone number fields
            if (evt.key === "+") {
                return true;
            }

            // If char is a special char (Firefox)
            if ( evt.which < 33 ) {
                return true;
            }

            let input = String.fromCharCode( charCode );
            // Char is a number or a space
            if ( ( /[\d\s]/.test( input ) ) ) {
                return true;
            }
            else {
                evt.preventDefault();
                return false;
            }
        },
        formatCardNumber: function(e) {
            // Only format if input is a number
            let digit = String.fromCharCode(e.which);
            if (!/^\d+$/.test(digit)) {
                return; 
            }
            let target = e.currentTarget;
            let value = target.value;
            // Return if focus isn't at the end of the text
            if ((target.selectionStart != null) &&
            (target.selectionStart !== value.length)) {
                return; 
            }

        },
        formatExpiry: function( e ) {
            // Only format if input is a number
            let digit = String.fromCharCode( e.which );
            if ( !/^\d+$/.test( digit ) ) {
                e.preventDefault();
                return; 
            }

            let target = e.currentTarget;
            let val = target.value + digit;

            if ( /^\d$/.test( val ) && ![ "0", "1" ].includes( val ) ) {
                e.preventDefault();
                return setTimeout( () => target.value = ( `0${ val }/` ) );

            }
            else if ( /^\d\d$/.test( val ) ) {
                e.preventDefault();
                return setTimeout( function() {
                    // Split for months where we have the second digit > 2 (past 12) and turn
                    // that into (m1)(m2) => 0(m1) / (m2)
                    let m1 = parseInt( val[ 0 ], 10 );
                    let m2 = parseInt( val[ 1 ], 10 );
                    if ( ( m2 > 2 ) && ( m1 !== 0 ) ) {
                        return target.value = ( `0${ m1 }/${ m2 }` );
                    }
                    else {
                        return target.value = ( `${ val }/` );
                    }
                } );
            }
        },
        characterTotalFormat( total, data, evt, char ) {
            if ( data.length >= total && char !== 8 ) {
                evt.preventDefault();
                return false;
            }
            return char !== 8;
        },
        isEmail( value ) {
            this.isNotEmpty( value );
            const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
            return emailRegex.test( value );
        },
        isNotEmpty( value ) {
            return value.length >= 1;

        },
        isSize( value, max, min = 0 ) {
            return value.length > min && value.length <= max;
        },
        isExact( value, length ) {
            return value.length === length;
        },
        isMatch( value, secondValue ) {
            return value === secondValue;
        },
        goBack: function() {
            window.history.back();
        },
        adaptStateToDevice() {
            const vw = Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 );
            return vw > 576;
        },
        emitToggleViewPayments( state ) {
            this.$emit( "toggle-view-payments", state );
        },
        emitLocaleSwitch(state) {
            this.$emit("toggle-locale", state);
        },
        translate(key, fallback = "") {
            if (!this.$t) {
                return fallback || key;
            }
            try {
                const word = this.$t(key);
                if (word === key) {
                    // Translation isn't found.
                    return fallback || key;
                }
                else {
                    return word;
                }
            }
            catch (err) {
                return fallback || key;
            }
        },
        validateCardholderName(value, evt) {
            const CARD_NAME_REGEX = /^[a-zA-Z\s'-]{1,50}$/;
            let input = typeof value === "string" ? value : String.fromCharCode( value );

            if (CARD_NAME_REGEX.test(input)) {
                return true;
            }
            else {
                evt.preventDefault();
                return false;
            }
        },

    },
};